import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {Body} from 'shells/typography/body';

import {MfaFlashBanner} from '../../auth/mfa/mfa-flash-banner';

type Props = {
    requireTwoFactor: string;
    setRequireTwoFactor: (requireTwoFactor: string) => void;
    hasMfaToken: boolean;
    isLoading: boolean;
};

export function MfaSettingsSection(props: Props) {
    if (props.isLoading) {
        return <LoadingPage />;
    }

    return (
        <div className='pad-16'>
            <StackLegacy spacing={16}>
                <Body size='small'>
                    <strong>Two-factor authentication</strong> makes your account more secure by
                    requiring a code when you login as well as your email and password. This code is
                    generated by an authenticator app or sent via text message.
                </Body>
                <Body size='small' color='light' isBold={true}>
                    Require two-factor authentication for:
                </Body>
                <div className={props.hasMfaToken ? '' : 'disabled'}>
                    <RadioGroup
                        name='require-two-factor'
                        selectedValue={props.requireTwoFactor}
                        onChange={(value) => {
                            props.setRequireTwoFactor(value);
                        }}
                        spacing={2}
                    >
                        <Radio value='1' size={13} disabled={!props.hasMfaToken}>
                            All users
                        </Radio>
                        <Radio value='0' size={13} disabled={!props.hasMfaToken}>
                            No on (Users can opt in or out themselves)
                        </Radio>
                    </RadioGroup>
                </div>
            </StackLegacy>
            {!props.hasMfaToken && (
                <div className='mt-16'>
                    <MfaFlashBanner />
                </div>
            )}
        </div>
    );
}
